/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendD1OverviewResponseDto } from '../../models/backend-d-1-overview-response-dto';

export interface GetOverviewEndpointDashboardsD1OverviewGet$Params {
  /**
   * ID проекта (обязательно)
   */
  project_id: number;
}

export function getOverviewEndpointDashboardsD1OverviewGet(
  http: HttpClient,
  rootUrl: string,
  params: GetOverviewEndpointDashboardsD1OverviewGet$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendD1OverviewResponseDto>> {
  const rb = new RequestBuilder(rootUrl, getOverviewEndpointDashboardsD1OverviewGet.PATH, 'get');
  if (params) {
    rb.query('project_id', params.project_id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendD1OverviewResponseDto>;
    }),
  );
}

getOverviewEndpointDashboardsD1OverviewGet.PATH = '/dashboards/d1/overview';
